// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchInput_container__8x3n7","input":"SearchInput_input__3wPd9"};